// approved/state.js

import { delFormInitialState } from "../../../forms/delForm/delFormState";

export const activeDelApprovedInitialState = {
  tabName: "approved",
  isLoading: false,
  error: null,
  delMode: null,
  currentDel: null,
  delErrors: null,
  delActiveTab: "projects",
  delShowAll: false,
  delForm: delFormInitialState,
};
